import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import type {
  Block,
  Document,
  Inline,
  Text,
} from "@contentful/rich-text-types";
import React from "react";

import { useLexicon } from "../context/LexiconContext";
import InternalLink from "./InternalLink";

interface Props {
  absolutePath?: string;
  linkPath: string;
  linkTitle: string;
  rawTruncated: Document;
}

const isTextNode = (node: Block | Text | Inline): node is Text =>
  node.nodeType === "text";

const TruncatedMessage: React.FC<Props> = ({
  absolutePath = "",
  linkPath,
  linkTitle,
  rawTruncated,
}) => {
  const { readMore } = useLexicon();
  const lastTextNode = rawTruncated.content
    .reduce<Text[]>(
      (nodes, item) => [...nodes, ...item.content.filter(isTextNode)],
      []
    )
    .pop();

  const readMoreDisabledPaths = ["https://www.omo.com/br/home.html"];

  return (
    <article className="px-4 py-16 md:px-18 lg:px-40 max-w-container mx-auto">
      {documentToReactComponents(rawTruncated, {
        renderText: (text) => (
          <>
            {text}
            {!readMoreDisabledPaths.includes(absolutePath) &&
              text === lastTextNode?.value && (
                <InternalLink
                  aria-label={`${readMore}: ${linkTitle}`}
                  className="font-bold text-[color:var(--link-color)] hover:text-[color:var(--link-color-hover)] ml-2"
                  href={linkPath}
                >
                  {readMore}
                </InternalLink>
              )}
          </>
        ),
      })}
    </article>
  );
};

export default TruncatedMessage;
